<template>
  <div class="integral-center-container">
    <el-row>
      <el-col :span="24">
        <el-row class="tcf-row" :gutter="20">
          <el-col :span="16" style="min-height:160px;" v-loading="categoryLoading">
            <div class="card">
              <div class="card-body" style="padding: 1rem;">
                <div class="card-title" style="margin-bottom:10px;">
                  商品分类
                </div>
                <div class="card-content">
                  <div class="category-area">
                    <div class="category" v-for="category in categoryData" @click="changeCategory(category.igtid)">
                      <el-image :src="category.img_url" fit="cover"/>
                      <p>{{category.name}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8" style="min-height:160px;" v-loading="lotteryLoading">
            <div class="card">
              <div class="card-body" style="padding: 1rem;">
                <el-carousel v-if="integralLottery.length>0" class="integral-lottery" height="130px" :interval="5000" indicator-position="none">
                  <el-carousel-item v-for="il in integralLottery">
                    <div class="banner-item" :style="'background-image:url('+il.img_url+')'"></div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="tcf-row" style="padding-top:0">
          <el-col :span="24">
            <div class="card">
              <div class="card-body" style="min-height:400px;">
                <div style="height:40px;margin-bottom:10px;">
                  <div style="float:left;">
                    <el-button type="text" :style="type===1?'color:#99a9bf':''" @click="changeType(0)">最新</el-button>
                    <el-button type="text" :style="type===0?'color:#99a9bf':''" @click="changeType(1)">最热</el-button>
                  </div>
                  <div class="search-mode">
                    <input type="text" class="search-input" placeholder="关键字搜索" v-model="search" />
                    <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
                  </div>
                </div>
                <el-row :gutter="20" v-loading="goodsLoading">
                  <div style="text-align: center;font-size: 13px;color:#99a9bf;margin-top:100px;" v-if="goodsData.length===0">
                    暂无数据
                  </div>
                  <el-col :span="4" v-for="good in goodsData" >
                    <el-card :body-style="{ padding: '0px' }" class="goods-item" shadow="hover">
                      <router-link :to="{path:'/my/goods_detail/'+good.goods_id}">
                        <el-image :src="good.img_url" style="width: 100%;min-height: 150px;" fit="cover">
                          <div slot="error" class="image-slot" style="height: 150px;text-align: center;line-height: 150px;font-size: 30px;color: #99a9bf;">
                            <i class="el-icon-picture-outline"/>
                          </div>
                        </el-image>
                        <div style="padding: 14px;">
                          <span>{{good.goods_name}}</span>
                          <div class="bottom">
                            <p>{{ good.all_name }}</p>
                          </div>
                          <div class="price">
                            <span class="price-red"><i class="el-icon-coin"/> {{good.price}}</span>
                            <span class="exchange">已兑换：{{good.exchange}}</span>
                          </div>
                        </div>
                      </router-link>
                    </el-card>
                  </el-col>
                </el-row>
                <div class="loading" v-loading="nextLoading" element-loading-background="rgba(0, 0, 0, 0)">
                  <el-button v-if="isHaveNextPage&&!nextLoading" @click="getGoodsNextPage">加载更多 <i class="el-icon-arrow-down"></i></el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { getGoodsClassify} from '@/api/my'
  import { getGoodsList} from '@/api/my'
  import { getLottery } from '@/api/my'
  import { getUser } from '@/utils/auth'

  export default {
    name: 'integral_center',
    computed: {
      user: getUser
    },
    created() {
      this.getGoodsList()
      this.getLotteryData()
      this.getGoodsClassify()
    },
    data(){
      return{
        integralLottery: [],
        goodsData: [],
        categoryData: [],
        pageSize: 18,
        currentPage: 1,
        categoryId: '',
        type: 0,
        search: '',
        isHaveNextPage: true,
        categoryLoading: false,
        goodsLoading: false,
        lotteryLoading: false,
        nextLoading: false
      }
    },
    methods:{
      getLotteryData() {
        this.lotteryLoading = true
        getLottery().then(response=>{
          this.integralLottery = response.data
          this.lotteryLoading = false
        })
      },
      getGoodsClassify(){
        this.categoryLoading = true
        getGoodsClassify().then(response=>{
          this.categoryData = response.data
          this.categoryLoading = false
        })
      },
      getGoodsList(){
        this.goodsLoading = true
        const data = {
          type: this.type,
          page: this.currentPage,
          limit: this.pageSize,
          category: this.categoryId,
          content: this.search
        }
        getGoodsList(data).then(response=>{
          this.isHaveNextPage = response.data.length >= this.pageSize;
          this.goodsData = this.goodsData.concat(response.data)
          this.goodsLoading = false
          this.nextLoading = false
        })
      },
      changeCategory(categoryId){
        this.categoryId = categoryId
        this.goodsData = []
        this.currentPage = 1
        this.getGoodsList()
      },
      changeType(type){
        this.type = type
        this.goodsData = []
        this.currentPage = 1
        this.getGoodsList()
      },
      getGoodsNextPage(){
        this.currentPage+=1
        this.nextLoading = true
        this.getGoodsList()
      },
      Search(){
        this.goodsData = []
        this.currentPage = 1
        this.getGoodsList()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .category-area{
    .category{
      height: 100px;
      width: 80px;
      padding: 8px;
      float: left;
      margin-left: 10px;
      cursor: pointer;
      .el-image{
        width: 65px;
        height: 65px;
        border-radius: 5px;
      }
      p{
        font-size: 13px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin:0;
        text-align: center;
      }
    }
  }
  .integral-lottery{
    height: 130px;
    .banner-item{
      border-radius: 2px;
      width: 100%;
      height: 130px;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
  .goods-item{
    cursor: pointer;
    div{
      span{
        font-size: 14px;
      }
      .bottom{
        p{
          margin: 10px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        font-size: 13px;
        color:#99a9bf;
      }
      .price{
        line-height: 15px;
        .price-red{
          font-size: 14px;
          color:#e01222;
        }
        .exchange{
          font-size: 12px;
          color:#99a9bf;
          float: right;
        }
      }
    }
  }
  .loading{
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    margin-top: 20px;
  }
  .search-mode{
    width: 300px;
    position: relative;
    float: right;
    .search-input{
      background-color: #F2F6FC;
      border:0;
      height: 40px;
      line-height: 40px;
      border-radius: 4px;
      color: #606266;
      padding: 0 40px 0 15px;
      -webkit-appearance: none;
      font-size: 12px;
      width: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      outline: 0;
      &::-webkit-input-placeholder {
        color: #C0C4CC;
      }
      &::-ms-input-placeholder {
        color: #C0C4CC;
      }
    }
    .search-btn{
      position: absolute;
      right: 0;
      height: 40px;
      width: 40px;
      line-height: 40px;
      top: 0;
      border: 0;
      background: transparent;
      text-align: center;
      padding: 0;
    }
  }
</style>
